import _defineProperty from "D:/VUE\u5EB7\u4E50\u901A\u603B\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  "class": "TUI-contact-list-card"
};
var _hoisted_2 = {
  "class": "TUI-contact-list-card-left"
};
var _hoisted_3 = {
  "class": "TUI-contact-list-card-main"
};
var _hoisted_4 = {
  "class": "TUI-contact-list-card-main-name"
};
var _hoisted_5 = {
  key: 0,
  "class": "TUI-contact-list-card-main-other"
};
var _hoisted_6 = {
  "class": "TUI-contact-list-card-right"
};
var _hoisted_7 = {
  key: 0,
  "class": "TUI-contact-list-card-right-group-type"
};
var _hoisted_8 = {
  key: 1,
  "class": "TUI-contact-list-card-right-application"
};
var _hoisted_9 = {
  key: 0,
  "class": "TUI-contact-list-card-right-application-text"
};
import { computed, ref, watch } from "../../../../adapter-vue";
import TUIChatEngine, { TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import Avatar from "../../../common/Avatar/index.vue";
import { generateAvatar, generateName, acceptFriendApplication } from "../../utils";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    item: {
      "default": function _default() {
        return {};
      }
    },
    list: {
      "default": function _default() {
        return [];
      }
    },
    displayOnlineStatus: {
      type: Boolean,
      "default": function _default() {
        return false;
      }
    },
    userOnlineStatusMap: {
      "default": function _default() {
        return {};
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var isOnline = ref(false);
    var groupType = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, TUIChatEngine.TYPES.GRP_WORK, "Work"), TUIChatEngine.TYPES.GRP_AVCHATROOM, "AVChatRoom"), TUIChatEngine.TYPES.GRP_PUBLIC, "Public"), TUIChatEngine.TYPES.GRP_MEETING, "Meeting"), TUIChatEngine.TYPES.GRP_COMMUNITY, "Community");
    var otherContentForSow = computed(function () {
      var _props$item, _TUIChatEngine$TYPES, _props$item2, _TUIChatEngine$TYPES2, _props$item4;
      var content = "";
      if ((props === null || props === void 0 || (_props$item = props.item) === null || _props$item === void 0 ? void 0 : _props$item.type) === (TUIChatEngine === null || TUIChatEngine === void 0 || (_TUIChatEngine$TYPES = TUIChatEngine.TYPES) === null || _TUIChatEngine$TYPES === void 0 ? void 0 : _TUIChatEngine$TYPES.SNS_APPLICATION_SENT_TO_ME) || (props === null || props === void 0 || (_props$item2 = props.item) === null || _props$item2 === void 0 ? void 0 : _props$item2.type) === (TUIChatEngine === null || TUIChatEngine === void 0 || (_TUIChatEngine$TYPES2 = TUIChatEngine.TYPES) === null || _TUIChatEngine$TYPES2 === void 0 ? void 0 : _TUIChatEngine$TYPES2.SNS_APPLICATION_SENT_BY_ME)) {
        var _props$item3;
        content = (props === null || props === void 0 || (_props$item3 = props.item) === null || _props$item3 === void 0 ? void 0 : _props$item3.wording) || "";
      } else if (props !== null && props !== void 0 && (_props$item4 = props.item) !== null && _props$item4 !== void 0 && _props$item4.groupID) {
        var _props$item5;
        content = "ID:".concat(props === null || props === void 0 || (_props$item5 = props.item) === null || _props$item5 === void 0 ? void 0 : _props$item5.groupID);
      }
      return content;
    });
    var groupTypeForShow = computed(function () {
      var _props$item6;
      var type = "";
      if (props !== null && props !== void 0 && (_props$item6 = props.item) !== null && _props$item6 !== void 0 && _props$item6.groupID) {
        var _props$item7;
        type = groupType[props === null || props === void 0 || (_props$item7 = props.item) === null || _props$item7 === void 0 ? void 0 : _props$item7.type];
      }
      return type;
    });
    var showApplicationStatus = computed(function () {
      var _props$item8, _TUIChatEngine$TYPES3, _props$item9, _TUIChatEngine$TYPES4;
      if ((props === null || props === void 0 || (_props$item8 = props.item) === null || _props$item8 === void 0 ? void 0 : _props$item8.type) === (TUIChatEngine === null || TUIChatEngine === void 0 || (_TUIChatEngine$TYPES3 = TUIChatEngine.TYPES) === null || _TUIChatEngine$TYPES3 === void 0 ? void 0 : _TUIChatEngine$TYPES3.SNS_APPLICATION_SENT_BY_ME)) {
        // 我发出的好友申请
        return {
          style: "text",
          label: "等待验证"
        };
      } else if ((props === null || props === void 0 || (_props$item9 = props.item) === null || _props$item9 === void 0 ? void 0 : _props$item9.type) === (TUIChatEngine === null || TUIChatEngine === void 0 || (_TUIChatEngine$TYPES4 = TUIChatEngine.TYPES) === null || _TUIChatEngine$TYPES4 === void 0 ? void 0 : _TUIChatEngine$TYPES4.SNS_APPLICATION_SENT_TO_ME)) {
        // 我收到的好友申请
        return {
          style: "button",
          label: "同意",
          onClick: function onClick() {
            var _props$item10;
            acceptFriendApplication(props === null || props === void 0 || (_props$item10 = props.item) === null || _props$item10 === void 0 ? void 0 : _props$item10.userID);
          }
        };
      }
      return false;
    });
    watch(function () {
      return props.userOnlineStatusMap;
    }, function () {
      isOnline.value = getOnlineStatus();
    }, {
      immediate: true,
      deep: true
    });
    function getOnlineStatus() {
      var _props$item11, _props$userOnlineStat;
      return props.displayOnlineStatus && props.userOnlineStatusMap && ((_props$item11 = props.item) === null || _props$item11 === void 0 ? void 0 : _props$item11.userID) && ((_props$userOnlineStat = props.userOnlineStatusMap) === null || _props$userOnlineStat === void 0 || (_props$userOnlineStat = _props$userOnlineStat[props.item.userID]) === null || _props$userOnlineStat === void 0 ? void 0 : _props$userOnlineStat.statusType) === TUIChatEngine.TYPES.USER_STATUS_ONLINE;
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(Avatar, {
        "class": "TUI-contact-list-card-left-avatar",
        useSkeletonAnimation: "",
        url: _unref(generateAvatar)(props.item)
      }, null, 8, ["url"]), props.displayOnlineStatus ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": _normalizeClass({
          'online-status': true,
          'online-status-online': _unref(isOnline),
          'online-status-offline': !_unref(isOnline)
        })
      }, null, 2)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_unref(generateName)(props.item)), 1), _unref(otherContentForSow) ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(otherContentForSow)), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [_unref(groupTypeForShow) ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(groupTypeForShow)), 1)) : _createCommentVNode("", true), _unref(showApplicationStatus) ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_unref(showApplicationStatus).style === 'text' ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(TUITranslateService).t("TUIContact.".concat(_unref(showApplicationStatus).label))), 1)) : _unref(showApplicationStatus).style === 'button' ? (_openBlock(), _createElementBlock("button", {
        key: 1,
        "class": "TUI-contact-list-card-right-application-button",
        onClick: _cache[0] || (_cache[0] =
        //@ts-ignore
        function () {
          var _unref2;
          return _unref(showApplicationStatus).onClick && (_unref2 = _unref(showApplicationStatus)).onClick.apply(_unref2, arguments);
        })
      }, _toDisplayString(_unref(TUITranslateService).t("TUIContact.".concat(_unref(showApplicationStatus).label))), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]);
    };
  }
});